import { BottomSheetSelectBox } from "../BottomSheetSelectBox";
import * as S from "./bottomSheetContent.styles";
import { ReactComponent as IconFilter } from "../../../../styles/assets/svg/icon-filter.svg";
import { useState } from "react";
import { Button } from "../../../atoms/Buttons";
import { ReactComponent as IconReset } from "../../../../styles/assets/svg/icon-refresh.svg";
import { SearchType } from "../../../../interface/transportation";
import { destination } from "../../../../data/destination";
interface BottomSheetContent {
  search: SearchType[];
  setSearch: React.Dispatch<React.SetStateAction<SearchType[]>>;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setShowFilter: React.Dispatch<React.SetStateAction<boolean>>;
  onSearchHandler: () => void;
}

export const BottomSheetContent = ({
  search,
  setSearch,
  setIsOpen,
  setShowFilter,
  onSearchHandler,
}: BottomSheetContent) => {
  const [isReset, setIsReset] = useState<boolean>(false);

  return (
    <S.BottomSheetContent>
      <S.BottomSheetTop>
        <S.BottomSheetFilter>
          <IconFilter />
          <div style={{ whiteSpace: "nowrap" }}>검색필터 설정</div>
        </S.BottomSheetFilter>
      </S.BottomSheetTop>
      <S.BottomSheetSelect>
        <S.BottomSheetSelectDetailBox>
          <p>운송형태</p>
          <S.BottomSheetSelectDetail className="workPoint">
            <BottomSheetSelectBox
              isReset={isReset}
              search={search}
              setIsReset={setIsReset}
              setSearch={setSearch}
              label="왕복"
              type=""
            />
            <BottomSheetSelectBox
              isReset={isReset}
              search={search}
              setIsReset={setIsReset}
              setSearch={setSearch}
              label="편도"
              type=""
            />
            <BottomSheetSelectBox
              isReset={isReset}
              search={search}
              setIsReset={setIsReset}
              setSearch={setSearch}
              label="셔틀"
              type=""
            />
          </S.BottomSheetSelectDetail>
        </S.BottomSheetSelectDetailBox>
        <S.BottomSheetSelectDetailBox>
          <p>상차지</p>
          <S.BottomSheetSelectDetail className="workPoint">
            {destination.map((item, index) => {
              return (
                <BottomSheetSelectBox
                  key={index}
                  isReset={isReset}
                  search={search}
                  setIsReset={setIsReset}
                  setSearch={setSearch}
                  label={item.label}
                  type="(상)"
                />
              );
            })}
          </S.BottomSheetSelectDetail>
        </S.BottomSheetSelectDetailBox>
        <p>작업지</p>
        <S.BottomSheetSelectDetail className="workPoint">
          {destination.map((item, index) => {
            return (
              <BottomSheetSelectBox
                key={index}
                isReset={isReset}
                search={search}
                setIsReset={setIsReset}
                setSearch={setSearch}
                label={item.label}
                type="(작)"
              />
            );
          })}
        </S.BottomSheetSelectDetail>
        <p>하차지</p>
        <S.BottomSheetSelectDetail className="workPoint">
          {destination.map((item, index) => {
            return (
              <BottomSheetSelectBox
                key={index}
                isReset={isReset}
                search={search}
                setIsReset={setIsReset}
                setSearch={setSearch}
                label={item.label}
                type="(하)"
              />
            );
          })}
        </S.BottomSheetSelectDetail>
      </S.BottomSheetSelect>
      <S.BottomSheetButtonBox>
        <div className="small">
          <Button
            type="button"
            color="transparent"
            size="full"
            onClick={() => {
              setIsReset(true);
              setSearch([]);
            }}
          >
            <IconReset width={30} height={30} />
            초기화
          </Button>
        </div>
        <Button
          type="submit"
          size="full"
          onClick={() => {
            if (search.length !== 0) {
              setIsOpen(false);
              setShowFilter(true);
              onSearchHandler();
            } else {
              setIsOpen(false);
              setShowFilter(false);
              onSearchHandler();
            }
          }}
        >
          적용
        </Button>
      </S.BottomSheetButtonBox>
    </S.BottomSheetContent>
  );
};

export default BottomSheetContent;
